// src/locales/si/userRoles.js
export const userRoles = {
    createNewRole: "නව පරිශීලක භූමිකාවක් සාදන්න",
    definePermissions: "කණ්ඩායම් සාමාජිකයින් සඳහා අවසර සහ ප්‍රවේශ මට්ටම් නිර්වචනය කරන්න",
    basicInformation: "මූලික තොරතුරු",
    provideBasicDetails: "භූමිකාව පිළිබඳ මූලික විස්තර සපයන්න",
    roleName: "භූමිකාවේ නම",
    roleNamePlaceholder: "භූමිකාවේ නම ඇතුළත් කරන්න (උදා: කළමනාකරු, කාර්යමණ්ඩලය)",
    description: "විස්තරය",
    descriptionPlaceholder: "මෙම භූමිකාව සහ එහි වගකීම් පිළිබඳ විකල්ප විස්තරයක්...",
    descriptionHint: "අන් අයට මෙම භූමිකාවේ අරමුණ තේරුම් ගැනීමට උපකාර වන කෙටි විස්තරයක් සපයන්න",
    permissions: "අවසර",
    selectPermissions: "මෙම භූමිකාවට කළ හැකි ක්‍රියාමාර්ග තෝරන්න",
    selected: "තෝරාගත්",
    total: "මුළු",
    loadingPermissions: "අවසර පූරණය වෙමින්...",
    loadingPermissionsDesc: "අපි පවතින අවසර ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    roleNameRequired: "භූමිකාවේ නම අවශ්‍යය",
    roleNameMinLength: "භූමිකාවේ නම අවම වශයෙන් අක්ෂර 2ක් විය යුතුය",
    selectAtLeastOne: "කරුණාකර අවම වශයෙන් එක් අවසරයක් තෝරන්න",
    roleCreatedSuccess: "\"{{roleName}}\" භූමිකාව සාර්ථකව සාදන ලදී!",
    failedToCreate: "භූමිකාව සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToLoadPermissions: "අවසර පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    backToRoles: "භූමිකාවන් වෙත ආපසු",
    createRole: "භූමිකාව සාදන්න",
    manageUserRoles: "ඔබේ කණ්ඩායම සඳහා පරිශීලක භූමිකාවන් සහ අවසර කළමනාකරණය කරන්න",
    loadingRoles: "භූමිකාවන් පූරණය වෙමින්...",
    loadingRolesDesc: "අපි පරිශීලක භූමිකාවන් ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    searchRoles: "නම හෝ විස්තරය අනුව භූමිකාවන් සොයන්න...",
    searchResults: "භූමිකාවන් {{total}} න් {{count}} ක්",
    totalRoles: "භූමිකාවන් {{count}} ක්",
    noSearchResults: "භූමිකාවන් හමු නොවිණි",
    noSearchResultsDesc: "ඔබේ සෙවුම් පද වෙනස් කිරීමට උත්සාහ කරන්න හෝ සියලු භූමිකාවන් බැලීමට සෙවුම ඉවත් කරන්න.",
    clearSearch: "සෙවුම ඉවත් කරන්න",
    noRoles: "තවම පරිශීලක භූමිකාවන් නැත",
    noRolesDesc: "කණ්ඩායම් අවසර කළමනාකරණය කිරීම ආරම්භ කිරීමට ඔබේ පළමු පරිශීලක භූමිකාව සාදන්න.",
    createFirstRole: "පළමු භූමිකාව සාදන්න",
    noDescription: "විස්තරයක් සපයා නැත",
    moreActions: "තවත් ක්‍රියාමාර්ග",
    confirmDelete: "ඔබට '{{roleName}}' භූමිකාව මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    roleDeletedSuccess: "'{{roleName}}' භූමිකාව සාර්ථකව මකා දමන ලදී.",
    failedToDelete: "භූමිකාව මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    retry: "නැවත උත්සාහ කරන්න",
    editRole: "පරිශීලක භූමිකාව සංස්කරණය කරන්න",
    updatePermissions: "මෙම භූමිකාව සඳහා අවසර සහ ප්‍රවේශ මට්ටම් යාවත්කාලීන කරන්න",
    updateBasicDetails: "භූමිකාව පිළිබඳ මූලික විස්තර යාවත්කාලීන කරන්න",
    loadingRole: "භූමිකාව පූරණය වෙමින්...",
    loadingRoleDesc: "අපි භූමිකාවේ දත්ත ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    roleNotFound: "භූමිකාව හමු නොවිණි. එය මකා දැමී ඇති විය හැක.",
    failedToLoadRole: "භූමිකාවේ දත්ත පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    noChangesToSave: "සුරැකීමට වෙනස්කම් කර නැත.",
    roleUpdatedSuccess: "'{{roleName}}' භූමිකාව සාර්ථකව යාවත්කාලීන කරන ලදී!",
    failedToUpdate: "භූමිකාව යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    confirmDiscardChanges: "ඔබට නොසුරකින ලද වෙනස්කම් තිබේ. සුරකින්නේ නැතිව පිටවීමට ඔබට අවශ්‍යද?",
    updateRole: "භූමිකාව යාවත්කාලීන කරන්න",
    noChanges: "වෙනස්කම් නැත",
    unsavedChanges: "නොසුරකින ලද වෙනස්කම්",
    discardChanges: "වෙනස්කම් ඉවත දමන්න",
    systemRole: "පද්ධති භූමිකාව",
    confirmDuplicate: "'{{roleName}}' හි පිටපතක් සාදන්නද?",
    roleDuplicatedSuccess: "'{{roleName}}' භූමිකාව සාර්ථකව අනුපිටපත් කරන ලදී!",
    failedToDuplicate: "භූමිකාව අනුපිටපත් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    cannotDeleteRoleWithUsers: "භූමිකාව මකා දැමිය නොහැක. පරිශීලකයින් මෙම භූමිකාවට පවරා ඇත."
}